// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.before-login-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
}

.before-login-header {
  padding-left: 3rem;
  padding-right: 3rem;
  align-items: center;
}
@media (max-width: 992px) {
  .before-login-header {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
@media (max-width: 576px) {
  .before-login-header {
    display: none;
  }
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.bottom-buttons {
  display: none;
}
@media (max-width: 576px) {
  .bottom-buttons {
    display: flex;
    justify-content: center;
    padding: 1rem;
    background-color: #f8f9fa;
  }
}

.header-logo {
  width: 30px;
  height: 30px;
}
@media (max-width: 1024px) {
  .header-logo {
    width: 22px !important;
    height: 22px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EALF;IAMI,kBAAA;IACA,mBAAA;EAEF;AACF;AAAE;EAVF;IAWI,aAAA;EAGF;AACF;;AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAGF;;AADA;EACE,aAAA;AAIF;AAFE;EAHF;IAII,aAAA;IACA,uBAAA;IACA,aAAA;IACA,yBAAA;EAKF;AACF;;AAFA;EACE,WAAA;EACA,YAAA;AAKF;AAHE;EAJF;IAKI,sBAAA;IACA,uBAAA;EAMF;AACF","sourcesContent":[".before-login-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 100vh;\n}\n\n.before-login-header {\n  padding-left: 3rem;\n  padding-right: 3rem;\n  align-items: center;\n\n  @media (max-width: 992px) {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  @media (max-width: 576px) {\n    display: none;\n  }\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n.bottom-buttons {\n  display: none;\n\n  @media (max-width: 576px) {\n    display: flex;\n    justify-content: center;\n    padding: 1rem;\n    background-color: #f8f9fa;\n  }\n}\n\n.header-logo {\n  width: 30px;\n  height: 30px;\n\n  @media (max-width: 1024px) {\n    width: 22px !important;\n    height: 22px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
